import React from 'react'
import './Imageupload.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import axios from 'axios';
import { useAppConfig } from '../../AppConfigProvider';

function Imageupload({ fileBill, setFileBill, isImageUploaded, setIsImageUploaded, BillOCRDetails, setBillOCRDetails, setBillItems, setisFileTypeImg, setFullVendorsList, fullVendorsList, isNewVendor, setIsNewVendor, setOCRAddress, uId, isFileTypeImg, setSelectedOption, setSelectedOptionAddress, activeVendor, setActiveVendor, setActiveVendorFull }) {
    const appConfig = useAppConfig();
    var someDate = new Date();
    someDate.setDate(someDate.getDate() + 14); //number  of days to add, e.x. 15 days
    var dateFormated = someDate.toISOString().substr(0, 10);

    const userID = uId;
    const fileSelectedHandler = (e) => {
        e.preventDefault();
        setFileBill(e.target.files[0]);
        setIsImageUploaded({ isImage: true, isOcr: false });

        const formData = new FormData();
        // Update the formData object
        formData.append(
            "file",
            e.target.files[0]
        );

        // Details of the uploaded file
        console.log(e.target.files[0]);
        console.log(e.target.files[0].type);
        if (e.target.files[0].type.startsWith("image/")) {
            setisFileTypeImg(true);
        }
        else {
            setisFileTypeImg(false);
        }
        // Request made to the backend api
        // Send formData object


        axios.put(`${appConfig.backendUrl}api/v1/ocr/${userID}`, formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            },
        }).then(function (response) {
            console.log("OCR Vendor Details !!!!!!!!!!!22", response.data.billItems);
            axios.get(`${appConfig.backendUrl}api/v1/qbuser/userItems/${userID}`)
                .then(userItems => {
                    if (userItems.data.length > 0) {
                        userItems.data.forEach(userItem => {
                            const matchingItemIndex = response.data.billItems.findIndex(item => item.itemName === userItem.itemName);
                            if (matchingItemIndex !== -1 && (response.data.billItems[matchingItemIndex].itemName !== "VAT" || !response.data.isTaxRegistered)) {
                                response.data.billItems[matchingItemIndex].expenseAccountName = userItem.expenseAccountName;
                            }
                        });
                    }
                })
                .catch(error => console.error('Error fetching UserItemsList:', error));


            console.log("OCR Vendor Details", response.data);
            console.log("formData 2", formData);
            setBillOCRDetails(response.data);
            setBillOCRDetails(bill => ({ ...bill, userId: uId }));
            setBillOCRDetails(bill => ({ ...bill, isImage: isFileTypeImg }));
            if (response.data.dueDate.length <= 0) {
                setBillOCRDetails(bill => ({ ...bill, dueDate: dateFormated }));
            }
            setBillItems(response.data.billItems);
            setIsImageUploaded({ isImage: true, isOcr: true });
            setOCRAddress(response.data.vendorAddress);
            setSelectedOption(response.data.vendorName);
            setActiveVendor(response.data.vendorName);
            console.log("Active Vendor", activeVendor);
            setSelectedOptionAddress(response.data.vendorAddress);
            const OCRVendor = {
                vendorName: response.data.vendorName,
                vendorAddress: response.data.vendorAddress,
                venderPhone: response.data.venderPhone,
                currency: response.data.currency,
                payableAccName: "",
                userId: uId
            }
            fullVendorsList = response.data.vendorsList;
            console.log("Vendors from mongo:", response.data.vendorsList);

            response.data.vendorsList.forEach((item) => {
                if (item.vendorName === response.data.vendorName) {
                    console.log("THis is Old supplier: ", item.vendorName + " response.data.vendorsList : ", response.data.vendorName);
                    isNewVendor = false;
                    setIsNewVendor(false);
                    setBillOCRDetails(bill => ({ ...bill, vendorId: item.id }));
                    setBillOCRDetails(bill => ({ ...bill, currency: item.currency }));
                    setActiveVendorFull(item)
                    if (response.data.vendorAddress === "") {
                        setSelectedOptionAddress(item.vendorAddress);
                    }
                }
            });

            console.log("Is new supplier:", isNewVendor);
            if (isNewVendor) {
                setFullVendorsList([...fullVendorsList, OCRVendor]);
                setActiveVendorFull(OCRVendor)
            }
            else {
                setFullVendorsList([...fullVendorsList]);
            }

        });

    }



    return (
        <>
            <div className="file-inputs">
                <input type="file" name="fileUpload" onChange={fileSelectedHandler} accept="image/png, image/jpg, image/jpeg,application/pdf" />
                <button>
                    <i>
                        <FontAwesomeIcon icon={faPlus} />
                    </i>
                    <span className='btn-span'>Upload Invoice</span>
                </button>
            </div>

        </>
    )
}

export default Imageupload

